import Loading from "shared/components/Spin";
import { TEMPLATES } from "utils/constants";
import CollectionNeeds from "./CollectionNeeds";
import Comparison from "./Comparison";
import Contact from "./Contact";
import Contract from "./Contract";
import Default from "./Default";
import Fast from "./Fast";
import Quote from "./Quote";
import SelectProducts from "./SelectProducts";
import Upsells from "./Upsells";

const Templates = {
  Loading: Loading,
  [TEMPLATES.B2B.THEMES.B2B_AMELLIS.CONTACT]: Contact,
  [TEMPLATES.B2B.THEMES.B2B_AMELLIS.CONTRACT]: Contract,
  [TEMPLATES.B2B.THEMES.B2B_AMELLIS.QUOTE]: Quote,
  [TEMPLATES.B2B.THEMES.B2B_AMELLIS.FAST]: Fast,
  [TEMPLATES.B2B.THEMES.B2B_AMELLIS.COLLECTION_NEEDS]: CollectionNeeds,
  [TEMPLATES.B2B.THEMES.B2B_AMELLIS.SELECT_PRODUCTS]: SelectProducts,
  [TEMPLATES.B2B.THEMES.B2B_AMELLIS.COMPARISON]: Comparison,
  [TEMPLATES.B2B.THEMES.B2B_AMELLIS.UPSELLS]: Upsells,
  default: Default,
};
export default Templates;
